import formatMoney from "../../formatMoney";
import AnimatedNumber from "../AnimatedNumber";

function Metrics({ objects }) {
  return (
    <>
      <div className="d-flex flex-column flex-md-row gap-3">
        {objects.map((a, index) => {
          return (
            <div
              key={index}
              className="flex-fill d-flex flex-column p-4 rounded-3 bg-white cursor-pointer"
              style={{
                borderTop: `4px solid ${a.color}`,
                border: "1px solid #e9ecef",
                transition: "all 0.3s ease",
                minHeight: "140px",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-4px)";
                e.currentTarget.style.boxShadow =
                  "0 8px 16px rgba(0, 0, 0, 0.12)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 1px 3px rgba(0, 0, 0, 0.12)";
              }}
            >
              <div className="d-flex justify-content-between align-items-start mb-1">
                <div className="d-flex flex-column">
                  <p
                    style={{
                      fontSize: "0.75rem",
                      fontWeight: "500",
                      color: "#6c757d",
                      marginBottom: "0.5rem",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                    }}
                    className="m-0"
                  >
                    {a.label}
                  </p>
                  <h3
                    className={`m-0 fw-bold ${parseFloat(a.value) < 0 && "text-danger"}`}
                    style={{
                      fontSize: "1.5rem",
                    }}
                  >
                    &#8369;{" "}
                    <AnimatedNumber value={a.value} formatter={formatMoney} />
                  </h3>
                </div>
                <div
                  style={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "12px",
                    backgroundColor: `${a.color}15`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <i
                    style={{ color: a.color, fontSize: "1.5rem" }}
                    className={a.icon}
                  ></i>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}

export default Metrics;
